<template>
	<div>
		<el-table :data="listData.list" size="mini">
			<el-table-column type="index" label="ID" width="50" />
			<el-table-column label="服务名称" prop="skuName" min-width="120" />
			<el-table-column label="金额" prop="totalMoney" min-width="120" />
			<el-table-column label="订单状态" prop="statusText" min-width="120" />
			<el-table-column label="下单时间" prop="createTime" min-width="120" />
			<el-table-column label="服务时间" prop="visitTime" min-width="120" />
		</el-table>

		<el-pagination
			:current-page="listPram.page"
			:page-sizes="constants.page.limit"
			:layout="constants.page.layout"
			:total="listData.total"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange" />
	</div>
</template>

<script>
	// import * as customerApi from '@/api/customer'
	export default {
		props: {
			consumptionNumData: {
				type: Object,
				default: () => {},
			},
		},
		data() {
			return {
				constants: this.$constants,
				pram: {},
				listPram: {
					limit: this.$constants.page.limit[0],
					page: 1,
				},
				listData: [],
			};
		},
		mounted() {
			this.getConsumptionNum();
		},
		methods: {
			changeSource(id) {
				this.sourceList.forEach(item => {
					if (item.id === id) {
						this.pram.sourceName = item.name;
					}
				});
			},
			close() {
				this.$emit('hideEditDialog');
			},
			getConsumptionNum() {
				this.listPram.phone = this.consumptionNumData.phone;
				// customerApi.getConsumeRecord(this.listPram).then(res => {
				//   this.listData = res
				// })
			},
			handleSizeChange(val) {
				this.listPram.limit = val;
				this.getConsumptionNum();
			},
			handleCurrentChange(val) {
				this.listPram.page = val;
				this.getConsumptionNum();
			},
		},
	};
</script>

<style scoped></style>
